import { render, staticRenderFns } from "./BaseBreadcrumbMain.vue?vue&type=template&id=bf3b2d24"
import script from "./BaseBreadcrumbMain.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumbMain.vue?vue&type=script&lang=js"
import style0 from "./BaseBreadcrumbMain.vue?vue&type=style&index=0&id=bf3b2d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports